<!-- FullViewModal.vue -->
<template>
    <div
      class="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50"
      @click.self="$emit('close')"
    >
      <img :src="imageSrc" class="max-w-full max-h-full" />
    </div>
  </template>
  
  <script>
  export default {
    props: {
      imageSrc: String,
    },
    name: "FullViewModal",
  };
  </script>
  